
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/spares-accessories/[city]",
      function () {
        return require("private-next-pages/spares-accessories/[city]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/spares-accessories/[city]"])
      });
    }
  